export default __webpack_public_path__ + "static/media/Convention-center_rollover.871d2a9a.png";